import { req } from './axiosFun';
/**
 *展会管理
 */
// 查看所有展会(分页)
export const qryExhibitionList = (params) => { return req("post", "/yishantong-ui/exhibition/qryExhibitionList", params) };

// 修改展会状态
export const upStatus = (params) => { return req("post", "/yishantong-ui/exhibition/upStatus", params) };

//修改展会数据
export const upExhibition = (params) => { return req("post", "/yishantong-ui/exhibition/upExhibition", params) };

//新增展会数据
export const addExhibition = (params) => { return req("post", "/yishantong-ui/exhibition/addExhibition", params) };

//查看所有展会预约
export const qryReservedList = (params) => { return req("post", "/yishantong-ui/exhibition/qryReservedList", params) };

//修改展会预约信息
export const upReserved = (params) => { return req("post", "/yishantong-ui/exhibition/upReserved", params) };

//新增展会预约信息
export const addReserved = (params) => { return req("post", "/yishantong-ui/exhibition/addReserved", params) };

//修改展会预约审核状态
export const upReservedStatus = (params) => { return req("post", "/yishantong-ui/exhibition/upReservedStatus", params) };

//展会预约提前结束
export const upStatusEnd = (params) => { return req("post", "/yishantong-ui/exhibition/upStatusEnd", params) };

//删除展会
export const delZh = (params) => { return req("post", "/yishantong-ui/exhibition/delZh", params) };











// 勋章列表
export const medalList = (params) => { return req("post", "/yishantong-ui/medal/medalList", params) };

// 新增勋章
export const addMedal = (params) => { return req("post", "/yishantong-ui/medal/addMedal", params) };

//查询平台配置信息
export const qryPlatform = (params) => { return req("post", "/yishantong-ui/sys/qryPlatform", params) };





// 修改部门
export const upDepartment = (params) => { return req("post", "/yishantong-ui/department/upDepartment", params) };

// 删除部门
export const delDepartment = (params) => { return req("post", "/yishantong-ui/department/delDepartment", params) };

// 批量删除部门
export const delallDepartment = (params) => { return req("post", "/yishantong-ui/department/delallDepartment", params) };
/**
 *轮播图管理
 */
// 轮播图列表(分页)
export const qryShopBannerList = (params) => { return req("post", "/yishantong-ui/shopBanner/qryShopBannerList", params) };

// 新增轮播图
export const addShopBanner = (params) => { return req("post", "/yishantong-ui/shopBanner/addShopBanner", params) };

// 修改轮播图
export const upShopBanner = (params) => { return req("post", "/yishantong-ui/shopBanner/upShopBanner", params) };

// 删除轮播图
export const delShopBanner = (params) => { return req("post", "/yishantong-ui/shopBanner/delShopBanner", params) };

// 批量删除轮播图
export const delallShopBanner = (params) => { return req("post", "/yishantong-ui/shopBanner/delallShopBanner", params) };

/**
 *平台设置
 */

//编辑经验值设置
export const upExpRule = (params) => { return req("post", "/yishantong-ui/platform/upExpRule", params) };

//编辑经验值次数设置
export const upExpNumRule = (params) => { return req("post", "/yishantong-ui/platform/upExpNumRule", params) };

//编辑云币设置
export const upCoinRule = (params) => { return req("post", "/yishantong-ui/platform/upCoinRule", params) };

//编辑云币次数设置
export const upCoinNumRule = (params) => { return req("post", "/yishantong-ui/platform/upCoinNumRule", params) };

//编辑其他设置
export const upOtherRule = (params) => { return req("post", "/yishantong-ui/platform/upOtherRule", params) };

//编辑签到规则
export const upSignInRule = (params) => { return req("post", "/yishantong-ui/platform/upSignInRule", params) };

//编辑抽奖规则
export const upLotteryRule = (params) => { return req("post", "/yishantong-ui/platform/upLotteryRule", params) };

//编辑文案设置
export const upCopywritingRule = (params) => { return req("post", "/yishantong-ui/platform/upCopywritingRule", params) };

//编辑消息通知文案设置
export const upMessageNotificationRule = (params) => { return req("post", "/yishantong-ui/platform/upMessageNotificationRule", params) };

//编辑短信文案设置
export const upSmsRule = (params) => { return req("post", "/yishantong-ui/platform/upSmsRule", params) };

//编辑首页弹框设置
export const upHomePopupRule = (params) => { return req("post", "/yishantong-ui/platform/upHomePopupRule", params) };

//编辑数据库备份
export const upSqlBackupRule = (params) => { return req("post", "/yishantong-ui/platform/upSqlBackupRule", params) };

//编辑程序配置
export const upProgramRule = (params) => { return req("post", "/yishantong-ui/sys/upProgramRule", params) };



// WEBPACK FOOTER //
// ./src/api/platformApi.js